import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagAiTriangleAlertIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2479_49121)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1625 3H3.99663C2.8942 3 2 3.8942 2 4.99663V12.1747C2 12.7014 2.20824 13.2159 2.58797 13.5956L11.2972 22.3049C12.2404 23.248 13.7716 23.248 14.7147 22.3049L21.2926 15.727",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.50002 9.00249C7.77739 9.00249 8.00224 8.77764 8.00224 8.50027C8.00224 8.2229 7.77739 7.99805 7.50002 7.99805C7.22265 7.99805 6.9978 8.2229 6.9978 8.50027C6.9978 8.77764 7.22265 9.00249 7.50002 9.00249Z",
				fill: "currentColor",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_2479_49121)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M22.64 11.4717L17.729 2.66287C17.622 2.46921 17.4655 2.30742 17.2755 2.194C17.0855 2.08058 16.8688 2.01959 16.6475 2.01726C16.4262 2.01492 16.2083 2.07132 16.0159 2.1807C15.8236 2.29008 15.6637 2.44853 15.5525 2.63989L10.4567 11.3431C10.3444 11.5329 10.2843 11.749 10.2824 11.9696C10.2806 12.1901 10.3371 12.4072 10.4462 12.5989C10.5553 12.7905 10.7131 12.9499 10.9037 13.0609C11.0943 13.1719 11.3108 13.2306 11.5314 13.2309L21.5382 13.3366C21.7577 13.3387 21.9739 13.283 22.165 13.1751C22.3561 13.0672 22.5155 12.911 22.6272 12.722C22.7388 12.5331 22.7988 12.3181 22.801 12.0986C22.8033 11.8791 22.7478 11.6629 22.64 11.4717Z",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M16.6101 6.14453L16.592 8.85849",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M16.5625 10.6484L16.5669 10.6485",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2479_49121",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_2479_49121",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15.0112,
			height: 15.0112,
			fill: "white",
			transform: "translate(9.15845 1) rotate(0.604884)"
		})
	})] })]
});
export default SvgTagAiTriangleAlertIcon;
